import { useEffect, useRef } from 'react';
import { useStreamHandler } from '../useStreamHandler/useStreamHandler.js';
export const useStreamHandlerStateWrapper = ({ agentConfig, conversationSession, shouldStartConversation, }) => {
    const { state, sendUserMessage: handleSendMessage, startConversation, ...rest } = useStreamHandler({
        conversationEndpointUrl: conversationSession.conversationEndpointUrl,
        correlationId: conversationSession.correlationId,
        initialState: {
            uiMessages: conversationSession.historyMessages,
            showError: false,
        },
    });
    const hasStartedConversationRef = useRef(false);
    useEffect(() => {
        if (shouldStartConversation && !hasStartedConversationRef.current) {
            startConversation(agentConfig.agentId, agentConfig.chatSource);
            hasStartedConversationRef.current = true;
        }
        // suppressing this warning because we want to start the conversation only when shouldStartConversation changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldStartConversation]);
    const sendUserMessage = (message) => {
        handleSendMessage(message, agentConfig.agentId, agentConfig.chatSource);
    };
    return { state, sendUserMessage, ...rest };
};
//# sourceMappingURL=useStreamHandlerStateWrapper.js.map